interface IActiveLinks {
  id: string;
  pos: number;
  ref: HTMLDivElement;
}

const visibleLinks: IActiveLinks[] = [];

const addVisibleLink = (link: IActiveLinks) => {
  if (!visibleLinks.find((l) => l.id === link.id)) {
    visibleLinks.push(link);
  } else {
    const itemIndex = visibleLinks.findIndex((l) => l.id === link.id);
    if (itemIndex > -1) {
      visibleLinks[itemIndex] = link;
    }
  }
};

const removeVisibleLink = (link: string) => {
  if (visibleLinks.find((l) => l.id === link)) {
    const itemIndex = visibleLinks.findIndex((l) => l.id === link);
    if (itemIndex > -1) {
      visibleLinks.splice(itemIndex, 1);
    }
  }
};

const getCurrentActive = () => {
  const active = visibleLinks.sort((a, b) => b.pos - a.pos);
  return active.length > 0 ? active[0].id : '';
};

export { addVisibleLink, getCurrentActive, removeVisibleLink };
